import React, { useEffect, useState } from "react";

const RecentLocation = ({ customer_id, onSelectLocation }) => {
  const [recentLocations, setRecentLocations] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const url = `${process.env.REACT_APP_HOST_API_URL}/admin-user/old-appointment-location/`;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchRecentLocations = async () => {
      if (!customer_id) return;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ customer_id }),
        });

        if (response.ok) {
          const data = await response.json();
          setRecentLocations(data.data || []);
        } else {
          console.error("API response not OK", response.status);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchRecentLocations();
  }, [customer_id]);

  return (
    <div className="border mt-4 p-3 rounded shadow-sm">
      <h4 className="text-center mb-4" style={{ color: "#0564bf" }}>
        Customer Recent Locations
      </h4>

      {recentLocations.length === 0 ? (
        <p className="text-center text-muted">No previous locations found.</p>
      ) : (
        <div className="d-flex align-items-center justify-content-center flex-wrap">
          {recentLocations.map((location, index) => (
            <div
              key={index}
              className={`m-2 border rounded shadow-sm overflow-hidden ${
                selectedIndex === index ? "border-success border-3" : ""
              }`}
              style={{ width: "280px" }}
            >
              <iframe
                width="100%"
                height="180"
                src={`https://maps.google.com/maps?q=${location.latitude},${location.longitude}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                title={`map-${index}`}
              ></iframe>

              <div className="text-center p-2">
                <button
                  className={`btn btn-sm ${
                    selectedIndex === index ? "btn-success" : "btn-outline-success"
                  }`}
                  onClick={() => {
                    setSelectedIndex(index);
                    onSelectLocation(location); 
                  }}
                >
                  {selectedIndex === index ? "Selected" : "Use This Address"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentLocation;
